import api from 'api'
import DrupalContext from 'contexts/DrupalContext'
import { FetchContext } from 'contexts/FetchContext'
import { getDepartmentList, getEntityList } from 'helpers/params'
import useUrlParams from 'hooks/useUrlParams'
import { useContext, useEffect, useState } from 'react'
import { AppContext } from 'stores/App'

const useSearch = () => {
  const drupal = useContext(DrupalContext)
  const [state] = useContext(AppContext)

  const { urlParams, updateUrlParams } = useUrlParams()
  const [results, setResults] = useState({})
  const [fetchController, setFetchController] = useState()
  const { resultList, setResultList, isAppendResults, setIsAppendResults } =
    useContext(FetchContext)

  useEffect(() => {
    /**
     * Set initial state based on url parameters if state params are empty.
     */
    if (urlParams.length !== 0 && state.params.length === 0) {
      state.params = getDepartmentList(urlParams)
    }

    if (urlParams.length !== 0 && state.entity_params.length === 0) {
      state.entity_params = getEntityList(urlParams)
    }
    // On intitial load, if hits is greater than 200, set hits to 200 in url.
    if (urlParams.hits >= 200 && !isAppendResults) {
      updateUrlParams({ hits: 200 })
    }
    ;(async () => {
      try {
        if (fetchController) {
          fetchController.cancel()
          setFetchController(null)
        }

        const [fetchResults, controller] = api.fetchResults(
          urlParams,
          drupal,
          state.params,
          isAppendResults
        )

        setFetchController(controller)
        const {
          data,
          config: { baseURL, url, params },
        } = await fetchResults

        // Check if fetch is append or refetch
        if (!isAppendResults) {
          setResultList(data?.documentList.documents || {})
        } else {
          setResultList([...resultList, ...data?.documentList.documents])
          // unset isAppendResults after appending hits
          setIsAppendResults(false)
        }

        // TODO: Do we need documents here, after we've introduced resultList?
        const { documents, pagination, sortOptions } = data?.documentList || {}
        const { facets, stats, quicklinks } = data
        const { enrolledIn, orgNames, orgTypes } = data?.extraData || {}

        setFetchController(null)

        window.react.results = {
          data,
          request: {
            baseURL,
            url,
            params,
            endpoint: url.split('/').pop(),
          },
        }

        setResults({
          documents,
          quicklinks: (quicklinks && quicklinks.documents) || [],
          pagination,
          facets,
          stats,
          sortOptions,
          inputText: urlParams.q,
          enrolledIn,
          orgNames,
          orgTypes,
        })
      } catch (error) {
        console.log(error)
      }
    })()
  }, [urlParams, state])

  return results
}

export default useSearch
